module.exports = __webpack_public_path__ + "static/media/legal.6d54c00e.png";